import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { RECOMMENDATION_TYPES, NOT_AVAILABLE_DEFAULT_STR } from '@bingads-webui-campaign/recommendation-core';
import { isKeywordRecsChange } from '../const';
import template from './top-search-term.pug';

export class TopSearchTermColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, recommendationType }) {
    super({
      name: 'topSearchTerm',
      property: 'Opportunities/SearchTerms',
      title: i18n.getString('Details_View_Top_Search_Term') || '__Top search term__',
      bodyClasses: ['grid-column-topSearchTerm', 'actionable'],
      colClasses: ['col-longText'],
      type: 'string',
    });
    this.i18n = i18n;
    this.recommendationType = recommendationType;
  }

  template({ value: { Opportunities } }) {
    const { recommendationType, i18n } = this;
    const searchTermsField = (recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD) ?
      'SearchQueries' : 'SearchTerms';
    const searchTerms = _.chain(Opportunities).first().result(searchTermsField).value();
    const searchTermList = [];
    _.map(searchTerms, (item) => {
      const searchTerm = (recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD) ?
        item.SearchQuery : item.SearchTerm;
      const searchTermKpi = item.SRPV;
      searchTermList.push({ searchTerm, searchTermKpi });
    });

    let more;
    if (_.size(searchTermList) > 2) {
      more = `+${i18n.getString('Recommendation_Grid_Todo_More', {
        count: _.size(searchTermList) - 2,
      })}`;
    }
    return template({
      notDefault: isKeywordRecsChange(_.first(Opportunities), recommendationType, i18n),
      NOT_AVAILABLE_DEFAULT_STR,
      searchTermList,
      more,
    });
  }

  get property() {
    return {
      get: _.identity,
      key: 'Opportunities/SearchTerms',
    };
  }
}
